import initializeRecaptcha from './recaptcha-init';

document.addEventListener('DOMContentLoaded', () => {
  const contactForms = document.querySelectorAll('.contact-form');

  if (contactForms.length) {
    contactForms.forEach(form => {
      initializeContactFormValidation(form);
    });

    initializeRecaptcha();
  }

  function initializeContactFormValidation(form) {
    const elements = form.querySelectorAll('[required]');
    const submitButton = form.querySelector('[type="submit"]');

    if (submitButton) {
      submitButton.disabled = true;
    }

    form.addEventListener('invalid', event => {
      if (event.target.hasAttribute('required')) {
        event.preventDefault();
        setInvalidMessage(event.target);
      }
    }, true);

    form.addEventListener('change', event => {
      if (event.target.hasAttribute('required')) {
        validateElement(event.target, form);
        updateSubmitButtonState(form);
      }
    });

    form.addEventListener('submit', event => {
      const isValid = validateAllElements(elements, form);
      if (!isValid) {
        event.preventDefault();
      }
    });
  }

  function validateAllElements(elements) {
    let isValid = true;
    elements.forEach(element => {
      if (!validateElement(element)) {
        isValid = false;
      }
    });
    return isValid;
  }

  function validateElement(element) {
    if (element.value) {
      if (element.hasAttribute('data-pattern')) {
        const pattern = new RegExp(element.dataset.pattern);
        if (!pattern.test(element.value)) {
          setFieldInvalid(element);
          return false;
        }
      }
      setFieldValid(element);
      return true;
    } else {
      setFieldInvalid(element);
      return false;
    }
  }

  function setFieldValid(element) {
    element.classList.add('is-valid');
    element.classList.remove('is-invalid');
    element.parentElement.nextElementSibling.innerHTML = '';
    element.setAttribute('aria-invalid', 'false');
  }

  function setFieldInvalid(element) {
    element.classList.add('is-invalid');
    element.classList.remove('is-valid');
    setInvalidMessage(element);
    element.setAttribute('aria-invalid', 'true');
  }

  function setInvalidMessage(element) {
    const lang = document.documentElement.lang;
    const defaultMessage = lang && lang.startsWith('fr') ? 'Ce champ est requis' : 'This field is required';
    element.parentElement.nextElementSibling.innerHTML = element.dataset.invalidMessage || defaultMessage;
  }

  function updateSubmitButtonState(form) {
    const requiredElements = form.querySelectorAll('[required]');
    const validElements = form.querySelectorAll('[required].is-valid');
    const submitButton = form.querySelector('[type="submit"]');

    if (submitButton) {
      submitButton.disabled = requiredElements.length !== validElements.length;
    }
  }
});



// WEBPACK FOOTER //
// ./scripts/components/contact-form.js